import React from 'react';

import StorytellerUtils from 'lib/StorytellerUtils';
import { type ReactRendererProps } from '../shared/ComponentRegistry';

interface YouTubeValue {
  id: string;
  title?: string;
}

export const generateYoutubeIframeSrc = (youtubeId: string, autoplay: boolean = false): string => {
  let src = `https://www.youtube.com/embed/${youtubeId}?rel=0&showinfo=0`;

  if (autoplay) {
    src += '&autoplay=true';
  }

  return src;
};

export const ComponentYoutubeVideo = ({ componentData }: ReactRendererProps) => {
  const value = componentData.value as YouTubeValue;
  const typeClasses = StorytellerUtils.typeToClassesForComponentType(componentData.type);

  const youtubeSource = generateYoutubeIframeSrc(value.id, false);

  return (
    <div className={`component ${typeClasses}`}>
      <iframe src={youtubeSource} allowFullScreen title={value.title} />
    </div>
  );
};
